module.exports = __webpack_public_path__ + "static/media/btn_add.6fb07484.svg";